{
    "ORIGINS": {
        "ADI": "ADI",
        "BUSINESS_MANAGER": "BUSINESS_MANAGER",
        "EDITOR": "EDITOR",
        "PHOTO_ALBUMS": "PHOTO_ALBUMS",
        "SHARE_IT": "SHARE_IT",
        "SHOUT_OUT": "SHOUT_OUT",
        "STORES": "STORES",
        "WIX_MUSIC": "WIX_MUSIC",
        "WIX_VIDEO": "WIX_VIDEO",
        "VIDEO_MAKER": "VIDEO_MAKER",
        "DESIGN_SYSTEM": "DESIGN_SYSTEM"
    },
    "UNKNOWN_APPLICATION_ID": "_unknown",
    "MMGR_WINDOW_STYLE": "fullscreen",
    "MMGR_MAX_PARALLEL_UPLOADS": 6,
    "SINGLE": 0,
    "MULTIPLE": 1,
    "DEFAULT_LANGUAGE_CODE": "en",
    "MMGR_LANGS_BASE_URL": "https://static.parastorage.com/services/media-manager-api-langs/1.959.0/media-manager-api-langs-1.959.0/MMGR_API_",
    "MMGR_SELECTION_TYPE": [
        "single",
        "multiple"
    ],
    "MMGR_TRANSLATION_KEYS_MAP": {
        "title": "header",
        "submitButton": "footer.submit",
        "uploadButton": "uploader.upload",
        "description": {
            "private": "private_media.upload_restrictions_header_message",
            "external": "social_images.upload_restrictions_header_message",
            "public": "free_from_wix.upload_restrictions_header_message",
            "photoStock": "bigstock_images.upload_restrictions_header_message",
            "shutterStock": "shutterstock_images.upload_restrictions_header_message"
        },
        "tab": {
            "private": "private_media_tab",
            "external": "external_media_tab",
            "public": "public_media_tab",
            "photoStock": "photo_stock_tab",
            "shutterStock": "shutterstock_tab"
        },
        "noItems": {
            "allMediaFolder": {
                "header": "no_items.header_allMedia",
                "text": "no_items.text_allMedia"
            },
            "siteMediaFolder": {
                "header": "no_items.header_siteMedia",
                "text": "no_items.text_siteMedia"
            },
            "userMediaFolder": {
                "header": "no_items.header_user_folder",
                "text": "no_items.text_user_folder"
            }
        },
        "removeItems": {
            "item": {
                "title": "private_media.remove_confirmation.item.title",
                "text": "private_media.remove_confirmation.item.message"
            },
            "items": {
                "title": "private_media.remove_confirmation.items.title",
                "text": "private_media.remove_confirmation.items.message"
            },
            "folder": {
                "title": "private_media.remove_confirmation.folder.title",
                "text": "private_media.remove_confirmation.folder.message"
            }
        }
    },
    "MMGR_SERVICES_LIST_MAP": {
        "FACEBOOK": "facebook",
        "FLICKR": "flickr",
        "INSTAGRAM": "instagram",
        "PICASA": "picasa",
        "GOOGLE_DRIVE": "drive",
        "DROPBOX": "dropbox",
        "GOOGLE_PHOTOS": "googlePhotos",
        "DEVIANT_ART": "deviantArt",
        "500PX": "500px",
        "WIX_SITES": "wixSite",
        "DRIBBLE": "dribble",
        "VIMEO": "vimeo",
        "EXTERNAL_URL": "link"
    },
    "MMGR_TABS_MAP": {
        "MY_MEDIA": "private",
        "MY_SHAPE": "private",
        "MY_VECTOR_ART": "private",
        "MY_SHAPE_UOU": "private",
        "MY_IMAGE": "private",
        "MY_IMAGE_PRO": "private",
        "MY_IMAGE_UOU": "private",
        "MY_VIDEO": "private",
        "MY_VIDEO_PRO": "private",
        "MY_VIDEO_UOU": "private",
        "MY_MUSIC": "private",
        "MY_MUSIC_PRO": "private",
        "MY_MUSIC_UOU": "private",
        "MY_DOCUMENT": "private",
        "MY_DOCUMENT_PRO": "private",
        "MY_DOCUMENT_UOU": "private",
        "MY_FLASH": "private",
        "MY_FLASH_UOU": "private",
        "MY_FAVICON": "private",
        "MY_NETWORK": "external",
        "MY_DIGITAL_PRODUCT_IMAGE": "private",
        "MY_DIGITAL_PRODUCT_VIDEO": "private",
        "MY_DIGITAL_PRODUCT_DOCUMENT": "private",
        "MY_DIGITAL_PRODUCT_MUSIC": "private",
        "MY_DIGITAL_PRODUCT_ZIP": "private",
        "MY_ART_STORE_IMAGE": "private",
        "MY_WIX_MUSIC": "private",
        "MY_WIX_VIDEO": "private",
        "MY_RECOMMENDED": "custom",
        "MY_SOCIAL_POST": "private",
        "MY_VIDEO_MAKER_VIDEO": "private",
        "MY_VIDEO_MAKER_IMAGE": "private",
        "FREE_FROM_WIX": "public",
        "BIG_STOCK": "photoStock",
        "SHUTTER_STOCK_IMAGE": "shutterStock",
        "SHUTTER_STOCK_VIDEO": "shutterStockVideo",
        "UNSPLASH_IMAGE": "unsplash",
        "VISITORS": "visitorsUploads",
        "FAVORITES": "favorites",
        "TRASH": "trash",
        "HOME": "home",
        "NTT": "ntt"
    },
    "MMGR_RECOMMENDED_ACTION": {
        "caption": "",
        "linkTo": {
            "WIX_MEDIA": "public",
            "MY_MEDIA": "private",
            "DEFAULT": "private"
        }
    },
    "MMGR_IMAGE_ANALYSIS_OPTIONS": {
        "faces": [
            "face"
        ],
        "labels": [
            "label",
            "explicit_content"
        ],
        "dominantColors": [
            "color"
        ]
    }
}
